enum FontFamily {
    GraphikRegular = "'Graphik-Regular', sans-serif",
}

export default FontFamily;